/** Пустой / null / omitted → `""` (так хранит API). */
export function serializeFieldLabel(raw: unknown): string {
  if (raw == null) return "";
  return String(raw).trim();
}

export function readFieldLabel(raw: unknown): string {
  return serializeFieldLabel(raw);
}

/** Конструктор, экспорт, a11y: подпись или техническое имя. */
export function fieldAdminLabel(field: {
  label?: string | null;
  name?: string | null;
  id?: number | null;
}): string {
  const label = serializeFieldLabel(field.label);
  if (label) return label;
  const name = (field.name ?? "").trim();
  if (name) return name;
  return field.id != null ? `Поле #${field.id}` : "";
}
